export default "__VITE_ASSET__Di64gPVG__"